import Card from '../../components/card/Card';
import P from '../../components/texts/p/P';
import Image from '../../components/image/Image';
import Spinner from '../../components/Spinner/spinner';
import { InstrumentationProgress, InstrumentationStatus } from '../../types/interfaces';

interface LineStatusIndicatorProps {
  progress?: InstrumentationProgress;
}

const LineStatusIndicator: React.FC<LineStatusIndicatorProps> = ({ progress }) => {
  if (!progress) {
    return null;
  }

  switch (progress.status) {
    case InstrumentationStatus.IN_PROGRESS:
      return (
        <Card display='flex' alignItems='center' gap='8px'>
          <Spinner size='sm' variant='primary' />
          <P type='2' variant='neutral'>
            Procesando...
          </P>
        </Card>
      );

    case InstrumentationStatus.SUCCESS:
      return (
        <Card display='flex' alignItems='center' gap='8px'>
          <Image name='check_line' />
          <P type='2' variant='success' weight='bold'>
            Completado
          </P>
          {progress.duration !== undefined && (
            <P type='2' variant='neutral' modifier='weak'>
              ({progress.duration}s)
            </P>
          )}
        </Card>
      );

    case InstrumentationStatus.FAILED:
      return (
        <div>
          <Card display='flex' alignItems='center' gap='8px'>
            <Image name='warning_line' variant='warning' />
            <P type='2' variant='warning' weight='bold'>
              Error: {progress.error?.message || 'Error desconocido'}
            </P>
          </Card>
          {progress.error?.code === 'LIMIT_DUPLICATE' && (
            <div style={{ marginTop: '8px', marginLeft: '32px' }}>
              <P type='2' variant='warning' weight='bold'>
                Cargue esta carpeta manualmente
              </P>
            </div>
          )}
        </div>
      );

    case InstrumentationStatus.RETRYING:
      return (
        <Card display='flex' alignItems='center' gap='8px'>
          <Spinner size='sm' variant='warning' />
          <P type='2' variant='warning' weight='bold'>
            Reintentando...
          </P>
        </Card>
      );

    default:
      return null;
  }
};

export default LineStatusIndicator;


